import { createUseMutation } from 'api/common/createUseMutation'
import { postProjectSyncPreview } from 'api/fetchers/postBriefSyncPreview'

export const usePostProjectSyncPreview = createUseMutation({
  fetcher: postProjectSyncPreview,
})
